module.exports = __webpack_public_path__ + "static/media/Chenthoor_landscape_Logo-removebg-preview.36bf7a42.png";